module.exports = __webpack_public_path__ + "img/scenery-13.ce66e269.png";